import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {transactionsSlipDetail_template} from "../components/templates/transactionsSlipDetail_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class transactions_slip_detail extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected editForm: transactionsSlipDetail_template;

    protected getModuleName() {
        return "transactions_slip_detail";
    }

    buildContent(): Array<Element> {

        // create validation errors list template

        // create the transactions form
        this.editForm = new transactionsSlipDetail_template("editForm", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Payment Slip Details");
        return [this.editForm.build()];
    }

    fillPage(): void {
        this.getFormData();
    }

    protected goBackToSlips() {

        let userId: number;
        if (((userId = this.getVnAppZone().app.params.userId) && !isNaN(userId))) {

            let sourceTag = this.viewModel['editForm'].sourceTab();
            let url = '/users/profile/' + userId + '?tab=' + sourceTag;
            page.redirect(url);
        } else {

            page.redirect('/payment/documents/slip');
        }
    }

    protected releaseLock() {

        // request a lock release
        let usrReq_url: string = '/includes/actions/transactions.php';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["action", 'release_lock_edit_form'], ["data", this.getVnAppZone().app.params.id]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    //
    // obtain the dynamic data required to fill the form
    protected getFormData() {

        this.loadingIn(this.editForm.builtTemplate);

        let userId: number;
        let paymentId: number;

        let action: string;

        let url: any = window.location.href;
        let paramsString = url.split("?")[1];
        let paramValues = paramsString.split("&");
        let params = [];
        let datePaidPair = paramValues[0]
        let datePaidPram = datePaidPair.split("=");
        let datePaid = datePaidPram[1];
        let isPrintFlag = false;
        if (paramValues.length > 1) {
            let isPrintPair = paramValues[1]
            let isPrintParam = isPrintPair.split("=");
            isPrintFlag = isPrintParam[1];
        }

        if (((userId = this.getVnAppZone().app.params.userId) && !isNaN(userId))) {
            this.viewModel["editForm"].userId(userId);
            this.viewModel["editForm"].paymentId(datePaid);
        }
        let subViewModel = {
            isPrint: isPrintFlag,
            payment: {
                id: this.viewModel.editForm.paymentId
            },
            user: {
                id: this.viewModel.editForm.userId
            }
        };

        let usrReq_url: string = '/api/payment/transactions/slip/detail/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj) {

        return function () {
            if (req.request.readyState == 4) {

                let thisModule = (<transactions_slip_detail>obj);
                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {

                    obj.updateList(responseParsed.data);

                    obj.loadingOut(obj.editForm.builtTemplate);
                    obj.editForm.validationsList.clearMessages();
                    if (responseParsed.data.isPrint) {
                        window.print();
                        window.close();
                    }
                } else {
                    if (req.request.status == 423) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                        page.redirect('/payment/documents/slip');
                    } else {
                        let msg = "error: while obtaining the form data - (" + req.request.status + ")";
                        obj.editForm.validationsList.setSingleMessage({
                            field: "error",
                            "label": req.request.status,
                            message: msg
                        });
                        window.scrollTo(0, 0);
                    }
                }
            }
        }
    }

    protected updateList(responseParsed) {
        let _this = this;

        let currency = responseParsed.currency;
        let currencySymbol = responseParsed.currencySymbol;

        let entryTypesTotal = {};
        let brandTrxs = [];
        for(let brand of responseParsed.transactions){
            let brandTotal = 0;
            let transactionsToSet = [];

            for(let [key, value] of (<any>Object).entries(brand.entries)){
                let amount = 0;
                let transactions = [];
                for(let trx of value.trxs) {
                    amount += Number(((trx.idType == 1) ? trx.amount * -1 : trx.amount));
                    currencySymbol = trx.currency.symbol;
                    currency = trx.currency.currency;
                    transactions.push({
                        idTrx: trx.system + '-' + (trx.idReference ? trx.idReference : trx.id),
                        amount: (trx.idType == 1) ? ('-' + currencySymbol + trx.amount) : ( currencySymbol  + trx.amount),
                        description: trx.name,
                        dateTransaction: trx.dateTransaction.substring(0, 10),
                        entryType: trx.entryType.name,
                        project_name: trx.item,
                        icon: trx.entryType.name.toLowerCase().replaceAll(' ', '-')
                    })
                }
                brandTotal += Number(amount);
                let amountStr = (amount < 0) ? (currencySymbol + '0 (-' + currencySymbol + (amount * (-1)).toFixed(2) + ')') : (currencySymbol + amount.toFixed(2));
                transactionsToSet.push({item: key, trxs: transactions, total: amountStr, icon: key.toLowerCase().replaceAll(' ', '-')});
            }
            let brandTotalStr = (brandTotal < 0) ? (currencySymbol + '0 (-' + currencySymbol + (brandTotal * (-1)).toFixed(2) + ')') : (currencySymbol + brandTotal.toFixed(2));
            brandTrxs.push({name: brand.name, icon: brand.icon, total: brandTotalStr, entries: transactionsToSet});
        }

        let total = responseParsed.total;
        let totalString = (responseParsed.total < 0) ? (currencySymbol + '0 (-' + currencySymbol + (responseParsed.total * (-1)).toFixed(2) + ')') : (currencySymbol + responseParsed.total.toFixed(2));


        let taxes = responseParsed.taxes;
        let taxesToSet = [];
        let taxTotal = 0;
        for (let tax of taxes) {
            //if taxesToSet contains taxcode id, add to the total amount, else push a new entry
            let taxCodeIndex = taxesToSet.findIndex(taxCode => taxCode.id === tax.taxCode.id);

            if (taxCodeIndex > -1) {
                taxesToSet[taxCodeIndex].total = (+taxesToSet[taxCodeIndex].total + +Number(tax.amount)).toFixed(2);
            } else {
                taxesToSet.push({
                    id: tax.taxCode.id,
                    code: tax.taxCode.code,
                    rate: tax.taxCode.rate,
                    total: Number(tax.amount).toFixed(2)
                });
            }

            taxTotal = +taxTotal + +tax.amount;
        }

        let grandTotal = total + taxTotal;
        let grandTotalString = (grandTotal < 0) ? (currencySymbol + '0 (-' + currencySymbol + (grandTotal * (-1)).toFixed(2) + ')') : (currencySymbol + grandTotal.toFixed(2));

        // the user can change currency while past generated
        // transaction with another currency.
        // as currency info the payment.
        responseParsed.currency = currency;
        responseParsed.currencySymbol = currencySymbol;

        this.editForm.setPaymentId(responseParsed.paymentId);
        this.editForm.setEntryTypesTotal(entryTypesTotal);
        this.editForm.setTransactions(brandTrxs);
        this.editForm.setTotal(total);
        this.editForm.setTotalString(totalString);
        this.editForm.setGrandTotal(grandTotal);
        this.editForm.setGrandTotalString(grandTotalString);
        this.editForm.setUserInfo(responseParsed);
        this.editForm.setTaxes(taxesToSet);
        this.editForm.setCompany(responseParsed.company);
        if (responseParsed.company.id == 3 || responseParsed.company.id == 2) {
            this.overrideSnackAndPlSpecifics(responseParsed);
        }
    }

    private overrideSnackAndPlSpecifics(responseParsed) {

        this.editForm.setSplitLabelText('Invoice From');
        this.editForm.setPaymentDateText('Invoice Date');
        this.editForm.setShowCompanyInvoiceTo(true);
        this.editForm.setShowCompanyExtraInfo(true);
        this.editForm.setShowOtherTotals(true);
        this.editForm.setShowInvoiceId(true);
        this.editForm.setCompanyExtraInfo(responseParsed.company.extraInfo);
        this.editForm.setInvoiceId(responseParsed.invoiceId);

        // if user is freelancer
        if (responseParsed.classificationId == 1) {
            this.editForm.setInvoiceTitle('Self Bill Invoice');
        }

        if (responseParsed.user_fullLegalName) {

            this.editForm.setUserName(responseParsed.user_fullLegalName);
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/transactions_slip_detail.ts